import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTopOnReload } from "./utils/scroll.util";
import Layout from "./utils/layout.util";
import ErrorInfo from "./pages/errorInfo.page";
import HomePage from "./pages/home.page";
import ImprintPage from "./pages/imprint.page";
import PrivacyPage from "./pages/privacy.page";
import CookiesPage from "./pages/cookies.page";
import DownloadsPage from "./pages/downloads.page";
import DownloadsTosPage from "./pages/downloadsTos.page";
import VotePage from "./pages/vote.page";
import FinalistsPage from "./pages/finalists.page";
import WinnersPage from "./pages/winners.page";
import FaqPage from "./pages/faq.page";
import TheEventPage from "./pages/theEvent.page";

// Do not change order of CSS imports
// general
import "./App.css";
import "./styles/layout.style.css";
import "./styles/general.style.css";
import "./styles/text.style.css";
import "./styles/colors.style.css";

// Default overwrites
import "./styles/mobile.style.css";
import BrandCasesInfoPage from "./pages/brandCasesInfo.page";
import { ContentProvider } from "./content/content.context";
import AdminApp from "./admin/AdminApp";

function App() {
    return (
        <ContentProvider>
            <header>
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" /> {/* Stop iPhone auto-zoom in on input/textfields on select */}
            </header>

            <BrowserRouter /* basename="/tcg-awards-site" */>
                <ScrollToTopOnReload />

                <Routes>
                    {/* Admin CMS (outside the marketing Layout) */}
                    <Route path={`/admin/*`} element={<AdminApp />} />

                    {/* General */}
                    <Route path={``} element={Layout({ page: <HomePage />, header: false, footer: true, background: {} })} />
                    <Route path={`/imprint`} element={Layout({ page: <ImprintPage />, header: false, footer: true, background: {}, disableCookies: true })} />
                    <Route path={`/privacy`} element={Layout({ page: <PrivacyPage />, header: false, footer: true, background: {}, disableCookies: true })} />
                    <Route path={`/cookies`} element={Layout({ page: <CookiesPage />, header: false, footer: true, background: {}, disableCookies: true })} />
                    <Route path={`/downloads`} element={Layout({ page: <DownloadsPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/downloads-tos`} element={Layout({ page: <DownloadsTosPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/brand-cases-info`} element={Layout({ page: <BrandCasesInfoPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/faq`} element={Layout({ page: <FaqPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/the-event`} element={Layout({ page: <TheEventPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/vote`} element={Layout({ page: <VotePage />, header: false, footer: true, background: {} })} /> {/* Only live while voting is enabled in the admin */}
                    <Route path={`/finalists`} element={Layout({ page: <FinalistsPage />, header: false, footer: true, background: {} })} /> {/* Only live while finalists are enabled in the admin */}
                    <Route path={`/winners`} element={Layout({ page: <WinnersPage />, header: false, footer: true, background: {} })} /> {/* Only live once the show is over (admin) */}

                    {/* Error pages */}
                    <Route path={`*`} element={Layout({ page: <ErrorInfo />, header: false, footer: true, background: {} })} /> {/* 404 Page not found */}
                    <Route path={`/error`} element={Layout({ page: <ErrorInfo />, header: false, footer: true, background: {} })} />
                </Routes>
            </BrowserRouter>
        </ContentProvider>
    );
}

export default App;
